import React from "react";

import NotificationsPopup from "./NotificationsPopup";
import PrivacyLinksRow from "./PrivacyLinksRow";
import SoleSourceTitle from "newApp/controls/SoleSourceTitle";

const AccountContainer = ({ children, logoClassName, hideWKTrademark }) => (
    <div className="accountPage">
        <NotificationsPopup/>

        <div className="col-xs-12 login-header">
            <span className="image-container">
                <div className={logoClassName ? logoClassName : "transparentLogo"}/>
            </span>
        </div>
        <div className="row signIn-row">
            <div className="signIn-container">
                <div className="box">
                    <SoleSourceTitle hideWKTrademark={hideWKTrademark} />
                    {children}
                </div>
                <PrivacyLinksRow/>
            </div>
        </div>
    </div>
);

export default AccountContainer;

